import React from 'react';
import './index.sp.scss';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpStepProgressBar from 'components/molecules/SpStepProgressBar';
import SpInputTitle from 'components/molecules/SpInputTitle';
import SpPointComment from 'components/molecules/SpPointComment';
import PcErrorArea from 'components/molecules/PcErrorArea';

import {
  POINT_COMMENT_MAP
} from 'utils/constant';

const PresentSP = ({
  onClickMainButton,
  ExcelskillDisp,
  OtherSkillsDisp,
  skillOtherCmntDisp,
  valid,
}) => (
  <div className="">
    <div className="AddSkill SP">
      <SpBasicTemplate
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
      >
        <div className="sc-StepProgressBar">
          <SpStepProgressBar currentStep="4" />
        </div>
        <div className="titleArea">
          <div className="title">業務に用いるスキル</div>
        </div>

        <SpPointComment labelList={POINT_COMMENT_MAP.skillPointCmnt.labelList} pattern={POINT_COMMENT_MAP.skillPointCmnt.pattern} />

        <SpInputTitle
          title={ExcelskillDisp.title}
          subTitle={ExcelskillDisp.subTitle}
          label={ExcelskillDisp.label}
          list={ExcelskillDisp.list}
          type={ExcelskillDisp.type}
        />

        <div className="mT10" />

        <SpInputTitle
          title={OtherSkillsDisp.title}
          subTitle={OtherSkillsDisp.subTitle}
          label={OtherSkillsDisp.label}
          list={OtherSkillsDisp.list}
          type={OtherSkillsDisp.type}
        />

        <div className="skillOtherCmntDisp">
          <SpInputTitle
            title={skillOtherCmntDisp.title}
            label={skillOtherCmntDisp.label}
            list={skillOtherCmntDisp.list}
            value={skillOtherCmntDisp.value}
            type={skillOtherCmntDisp.type}
          />
          <span className="">
            <PcErrorArea
              position="relative"
              message={skillOtherCmntDisp.errorDispMessages}
            />
          </span>
        </div>
      </SpBasicTemplate>
    </div>
  </div>
);

export default PresentSP;
